export interface LoyaltyCreditCardFeatureFlag {
  hasResolvedFlag: boolean
  isEnabled: boolean
}

// Audience and region targeting live on the LE Lab campaign, so the page only
// needs the evaluated on/off decision. An undefined flag means the lab decide
// call has not resolved yet (or was skipped for bots).
export function resolveLoyaltyCreditCardFeatureFlag(
  flag: App.LabFeatureFlagResult | undefined,
): LoyaltyCreditCardFeatureFlag {
  return {
    hasResolvedFlag: flag !== undefined,
    isEnabled: !!flag?.enabled,
  }
}
